import "./DocumentCard.css";
import { Card, Tags, FileText } from "../../../ui";
import { useAccess } from "../../../../access/hooks/useAccess";

export default function DocumentCard({
  title,
  subtitle,
  status,
  statusVariant = "success",
  badge,
  badgeVariant = "primary",
  meta,
  children,
  icon,
  historyText,
  onClick,
  selected = false,
}) {
  const { can } = useAccess();

  return (
    <Card className={`lud-document-card ${selected ? "is-selected" : ""}`} hoverable onClick={onClick}>
      <div className="lud-document-card__top">
        <span className="lud-document-card__icon">
          {icon || <FileText size={21} />}
        </span>
        {badge && (
          <Tags variant={badgeVariant} size="sm">
            {badge}
          </Tags>
        )}
      </div>
      <div className="lud-document-card__body">
        <h3>{title}</h3>
        <p>{subtitle}</p>
        {children}
      </div>
      <footer>
        <span>{meta}</span>
        <Tags variant={statusVariant} size="sm">
          {status}
        </Tags>
      </footer>
      {historyText && can("ludDocument.history.view") ? <div className="lud-document-card__history">{historyText}</div> : null}
    </Card>
  );
}
